import { appendRoute } from "./appendRoute";

// team routes
export const teamRoute = {
  path: `/:teamId`,
  checkParams: ({ teamId }) => /^T\w{12}$/.test(teamId),
};

export const usersRoute = appendRoute(teamRoute, "/users");
export const configureRoute = appendRoute(teamRoute, "/configure");
export const projectsRoute = appendRoute(teamRoute, "/projects");
export const myRoute = appendRoute(teamRoute, "/my");
export const dataQueriesRoute = appendRoute(teamRoute, "/data_queries");
export const userSettingsRoute = appendRoute(teamRoute, "/user_settings");
export const superadminRoute = appendRoute(teamRoute, "/superadmin");
export const chatsRoute = appendRoute(teamRoute, "/chats");
export const documentsRoute = appendRoute(teamRoute, "/documents");
export const foldersRoute = appendRoute(teamRoute, "/folders");
export const companiesRoute = appendRoute(teamRoute, "/companies");
export const addSignatureRoute = appendRoute(teamRoute, "/add_signature");

export const itemRoute = appendRoute(teamRoute, "/:itemId", {
  checkParams: ({ itemId }) => /^[IDF]\w{12}$/.test(itemId),
});

export const fileRoute = appendRoute(teamRoute, "/:fileId", {
  checkParams: ({ fileId }) => /^I\w{12}$/.test(fileId),
});

export const folderRoute = appendRoute(teamRoute, "/:folderId", {
  checkParams: ({ folderId }) => /^F\w{12}$/.test(folderId),
});

export const documentRoute = appendRoute(teamRoute, "/:documentId", {
  checkParams: ({ documentId }) => /^D\w{12}$/.test(documentId),
});

export const groupRoute = appendRoute(teamRoute, "/:groupId", {
  checkParams: ({ groupId }) => /^G\w{12}$/.test(groupId),
});

export const userRoute = appendRoute(teamRoute, "/:userId", {
  checkParams: ({ userId }) => /^M\w{12}$/.test(userId),
});

export const dataQueryRoute = appendRoute(teamRoute, "/:dataQueryId", {
  checkParams: ({ dataQueryId }) => /^DQ\w{12}$/.test(dataQueryId),
});

export const picklistRoute = appendRoute(teamRoute, "/:picklistId", {
  checkParams: ({ picklistId }) => /^PICKLIST\w{12}$/.test(picklistId),
});

export const chatRoute = appendRoute(teamRoute, "/:chatId", {
  checkParams: ({ chatId }) => /^CHAT\w{12}$/.test(chatId),
});

export const companyRoute = appendRoute(teamRoute, "/:companyId", {
  checkParams: ({ companyId }) => /^COMPANY\w{12}$/.test(companyId),
});

export const pTemplateRoute = appendRoute(teamRoute, "/:pTemplateId", {
  checkParams: ({ pTemplateId }) => /^PTEMPLATE\w{12}$/.test(pTemplateId),
});

export const companyRegistrationRoute = appendRoute(
  teamRoute,
  "/:companyRegistrationId",
  {
    checkParams: ({ companyRegistrationId }) =>
      /^COMPANYREG\w{12}$/.test(companyRegistrationId),
  },
);
